import { createSlice } from "@reduxjs/toolkit"
import { themes } from "../../themes.js"

export const generalSlice = createSlice({
    name: 'general',
    initialState: {
        sideBarMobile: false,
        popup: '',
        search: '',
        upperPopup: '',
        preview: null,
        previewLan: 'he',
        callbackLink: '',
        themeName: 'youtube',
    },
    reducers: {
        toggleSideBarMobile: (state) => {
            state.sideBarMobile = !state.sideBarMobile
        },
        setPopup: (state, action) => {
            state.popup = action.payload
        },
        setSearch: (state, action) => {
            state.search = action.payload
        },
        setPreview: (state, action) => {
            state.preview = action.payload
        },
        setPreviewLan: (state, action) => {
            state.previewLan = action.payload
        },
        setUpperPopup: (state, action) => {
            state.upperPopup = action.payload
        },
        setScrollEl: (state, action) => {
            state.scrollEl = action.payload
        },
        setCallbackLink: (state, action) => {
            state.callbackLink = action.payload
        },
        setSelectedProfile: (state, action) => {
            state.selectedProfile = action.payload
        },
        setTheme: (state, action) => {
            const themeName = action.payload || 'youtube'
            const theme = themes[themeName]
            state.themeName = themeName
            const root = document.documentElement
            Object.entries(theme).forEach(([key, value]) => {
                root.style.setProperty(`--${key}`, value)
            })
        },
    }
})

export const {
    toggleSideBarMobile,
    setPopup,
    setSearch,
    setPreview,
    setPreviewLan,
    setUpperPopup,
    setScrollEl,
    setCallbackLink,
    setSelectedProfile,
    setTheme,
} = generalSlice.actions

export default generalSlice.reducer
